<template>
  <!-- v-if='tokenUser["admin"]' -->
  <div class="is-flex" :class="isMovil ? 'is-justify-center' : ''">
    <button
      v-if="tokenUser.admin"
      v-on:click="switchSideMenu"
      class="button is-dark"
    >
      Crear Empresa
      <span class="icon" style="margin-left: 5px">
        <i class="material-icons">add_circle</i>
      </span>
    </button>
    <button
      v-if="Object.keys(filter).length"
      v-tooltip="'Eliminar filtros'"
      v-on:click="clearFilter"
      class="button is-dark delete-filter"
      style="margin-left: 5px;"
    >
      <span class="icon">
        <i class="material-icons">filter_list</i>
      </span>
    </button>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  props: {
    filter: {
      type: Object,
    },
    tokenUser: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(["isMovil"]),
  },
  methods: {
    clearFilter() {
      this.$emit("clearFilter");
    },
    switchSideMenu() {
      this.$emit("switchSideMenu");
    },
  },
};
</script>
<style lang="scss" scoped>
.delete-filter:hover {
  background-color: red;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/empresas/components/MenuTableCompany.vue